var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "Retorno de vasilhames",
      "centered": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.aoFechar
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": _vm.cancelar
          }
        }, [_vm._v("Cancelar")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.confirmar
          }
        }, [_vm._v("Confirmar")])];
      },
      proxy: true
    }])
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Informe quantos cascos foram devolvidos para "), _c('strong', [_vm._v(" " + _vm._s(_vm.produto.descricao) + " ")]), _vm._v(" . ")]), _c('b-form-group', {
    attrs: {
      "label": "Quantidade vendida"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.quantidade,
      "disabled": ""
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Cascos devolvidos",
      "label-for": "quantidade-retornada"
    }
  }, [_c('b-form-input', {
    ref: "quantidadeRetornada",
    attrs: {
      "id": "quantidade-retornada",
      "type": "number",
      "min": "0",
      "max": _vm.quantidade,
      "step": "1"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.confirmar.apply(null, arguments);
      }
    },
    model: {
      value: _vm.quantidadeRetornada,
      callback: function callback($$v) {
        _vm.quantidadeRetornada = _vm._n($$v);
      },
      expression: "quantidadeRetornada"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Informe um número inteiro entre 0 e " + _vm._s(_vm.quantidade) + ". ")])], 1), _c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_vm._v("Com retorno (" + _vm._s(_vm.quantidadeComRetorno) + ")")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoeda(_vm.precoComRetorno)) + " cada")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('span', [_vm._v("Sem retorno (" + _vm._s(_vm.quantidadeSemRetorno) + ")")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoeda(_vm.precoSemRetorno)) + " cada")])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };